export enum CaseSubType {
  Maintenance = 'Maintenance',
  ActiveTreatment = 'Active Treatment',
}
